export default function IButton({ icon, label, onClick, className}) {
    return (
        <button onClick={onClick} className={`ibutton ${className}`}>
            {icon}{label}
        </button>
    );
}